/* import __COLOCATED_TEMPLATE__ from './row.hbs'; */
/**
Row component yielded by `sq-table`, not intended for standalone use.

### Parameters
@param {Boolean} [isSelected=false] - Whether the row is currently selected. Applies selected row styling.
@param {Function} [selectAction=null] - Action to call when the row is clicked. Passing this will also automatically apply selectable hover styling to the row.
```
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'tr',
  classNameBindings: ['isSelectable:table-row--selectable', 'isSelected:table-row--selectable-is-selected'],
  isSelected: false,
  selectAction: null,
  didReceiveAttrs() {
    this._super();
    this.set('isSelectable', typeof this.selectAction === 'function');
  },
  click() {
    if (this.isSelectable) {
      this.selectAction();
    }
  }
});